import { Infinity as Inf } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const n = (v) => (v || 0).toLocaleString("es-PY");

export function Continuo({ e, onCambio }) {
  const set = (activo) => api.post("/portal/barrido/continuo", { activo }).then(() => { toast.success(activo ? "Modo continuo encendido" : "Modo continuo apagado"); onCambio(); })
    .catch((x) => toast.error(formatApiErrorDetail(x?.response?.data?.detail)));
  const activas = e.distritos.filter((d) => d.activo);
  return <div className="bg-white rounded-xl border border-slate-200 p-4 space-y-3" data-testid="continuo-panel">
    <div className="flex flex-wrap items-center gap-3">
      <Inf className="w-5 h-5 text-[#1f5f3f]" />
      <div><b>Modo continuo</b><p className="text-[11px] text-slate-500">El backend encadena lotes de {e.tope_lote} por zona activa, uno a la vez (≥2 s entre consultas), hasta completar cada distrito. Si el SNC falla se pausa y reintenta solo (30 min; 3 h si bloquea).</p></div>
      <button onClick={() => set(!e.continuo)} className={`ml-auto rounded-full px-4 py-1.5 text-sm font-semibold ${e.continuo ? "bg-emerald-700 text-white" : "bg-slate-200 text-slate-700"}`} data-testid="continuo-toggle">
        {e.continuo ? "Encendido · apagar" : "Apagado · encender"}</button>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">{activas.map((d) => {
      const tot = (d.procesadas || 0) + (d.estado === "completo" ? 0 : d.total || 0);
      const pct = tot ? Math.round((100 * (d.procesadas || 0)) / tot) : 0;
      return <div key={d.cod} className="rounded-lg bg-slate-50 p-2 text-xs" data-testid={`continuo-zona-${d.cod}`}>
        <b>{d.nombre}</b> <span className="text-slate-400">({d.cod})</span>
        <p>{n(d.procesadas)} / {tot ? n(tot) : "?"} parcelas · {pct}%</p>
        <div className="h-1.5 bg-slate-200 rounded"><div className="h-1.5 rounded bg-emerald-600" style={{ width: `${pct}%` }} /></div>
        <p className="text-slate-500">{n(d.vinculos)} vínculos · {d.estado === "corriendo" ? "barriendo" : d.estado}</p>
      </div>;
    })}</div>
  </div>;
}
